var wizardInit = function () {
    $(".wizard h3").each(function () {
        var source = $(this);
        var container = $(this).parent();

        var children = container.children("ul").children("li");

        $(children).each(function () {
            var target = $(this).find("h2")[0];
            if (target) {
                source.connections({ to: $(target) });
            }
        });
    });

    $(".wizard h2").each(function () {
        var source = $(this);
        var container = $(this).closest("li");

        var children = container.children("ul").children("li");

        $(children).each(function () {
            var target = $(this).find("h3")[0];
            if (target) {
                source.connections({ to: $(target) });
            }
        });
    });

    var bindEvents = function () {
        $("[data-id='wizard-dropdown-button']").off("click").on('click', function (evt) {
            evt.preventDefault();

            var container = getContainer($(this));

            if (container != null) {
                var questionId = getQuestionId(container);
                var dropdown = $("select[name='choiceId']", container);

                if (dropdown.length) {
                    var choiceId = dropdown.val();

                    var data = {
                        fhController: 'WizardController',
                        fhAction: 'AjaxStart',
                        questionId: questionId.val(),
                        choiceId: choiceId
                    };

                    answerQuestion(data, container);
                }
            }
        });

        $("[data-id='wizard-yesno-button']").off("click").on('click', function (evt) {
            evt.preventDefault();

            var container = getContainer($(this));

            if (container != null) {
                var questionId = getQuestionId(container);

                var data = {
                    fhController: 'WizardController',
                    fhAction: 'AjaxStart',
                    questionId: questionId.val(),
                    choiceId: $(this).val()
                };

                answerQuestion(data, container);

                $("[data-id='wizard-yesno-button']", $(this).parent()).removeClass('active');
                $(this).addClass('active');
            }
        });
    };

    bindEvents();

    var answerQuestion = function (postData, container) {
        var submitUrl = $("[data-id='question-post-url']");

        $.post(submitUrl.val(), postData, function (data) {
            if (data.length) {
                const newElement = $(data);
                removeOldQuestions(container);
                container.after(newElement);
                bindEvents();
                newElement.show(200);
                newElement.find(":tabbable").first().focus();
                $('.m-wysiwyg table').wrap("<div class='responsive-outer' />");
            }
            else {
                console.log('Problem submitting question');
            }
        });
    };

    var getContainer = function (element) {
        return element.parents('.m-form').first();
    };

    var getQuestionId = function (container) {
        return $("input[type='hidden'][name='questionId']", container);
    };

    var removeOldQuestions = function (container) {
        container.nextAll().each(function (evt) {
            $(this).remove();
        });
    };
}
